// extracted by mini-css-extract-plugin
export default {"textCheckboxListSide":"_5nbgR68OYybsHtY5gezg","checkboxText":"MHm4Koew6JMYxvbV2gEY","twoColumns":"ByOlD4MMBKY67BShV16D","count":"TIIluHiz4LwXrh90_2q_"};